// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header-back[data-v-1cc07232] {
  font-size: 19px;
  display: flex;
  align-items: center;
}
.header-back i[data-v-1cc07232] {
  color: var(--toolbtn-color);
}
.header-back i[data-v-1cc07232]:hover {
  color: var(--toolbtn-color-hover);
}
`, "",{"version":3,"sources":["webpack://./js/app/components/main/header/MainHeader.vue"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,iCAAiC;AACnC","sourcesContent":[".header-back[data-v-1cc07232] {\n  font-size: 19px;\n  display: flex;\n  align-items: center;\n}\n.header-back i[data-v-1cc07232] {\n  color: var(--toolbtn-color);\n}\n.header-back i[data-v-1cc07232]:hover {\n  color: var(--toolbtn-color-hover);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
